(function () {
  'use strict';

  /* ── Config from Liquid ─────────────────────────────────── */
  var cfg           = window.FRM_FLOOR_CALC || {};
  var PACK_COVERAGE = parseFloat(cfg.sqmPerBox)   || 1.805;
  var PRICE_CENTS   = parseInt(cfg.sqmPriceCents, 10) || 0;
  var CURRENCY      = cfg.currencySymbol || '$';

  /* Pack-quantity mode (new_flooring_products template only, opted in via
     Liquid's pricingMode: 'pack'): cart quantity is always packs (a whole
     number — Shopify can't bill fractional sqm), and checkout charges
     quantity × the stored variant price. Shopify's Price field IS the
     sqm rate (what admin enters) — PACK_PRICE below is that same rate,
     so totalCost = packs × PACK_PRICE matches real checkout billing
     exactly. It is NOT the coverage-adjusted "true" pack cost — that
     figure is shown separately, as a reference only, in the page header
     (see frm-flooring-product-v2.liquid). Left as an additive branch so
     the original template's legacy formula (pricingMode absent) is
     completely unaffected. */
  var PRICING_MODE = cfg.pricingMode || 'sqm';
  /* Liquid's variant.price outputs in cents (e.g. 9499 for $94.99) when
     interpolated raw, same as sqmPriceCents above — divide by 100 here
     too, or every pack-mode total ends up 100x too large. */
  var PACK_PRICE    = (parseFloat(cfg.packPrice) || 0) / 100;

  function calcTotal(packs, suppliedSqm) {
    return PRICING_MODE === 'pack' ? (packs * PACK_PRICE) : ((suppliedSqm * PRICE_CENTS) / 100);
  }
  function hasPrice() {
    return PRICING_MODE === 'pack' ? PACK_PRICE > 0 : PRICE_CENTS > 0;
  }

  function fmt(n) {
    return CURRENCY + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* Exact m² display — no forced 2dp rounding. Pack coverage varies by
     product (e.g. 2.166), so packs × coverage must show its real value
     (2.166) rather than a rounded one (2.17). Trims trailing zeros. */
  function fmtSqm(n) {
    return parseFloat(n.toFixed(3)).toString();
  }

  /* Pure pack calculation — Math.ceil always rounds up.
     e.g. 4 / 1.805 = 2.216 → 3 packs */
  function calcPacks(requestedSqm, packCoverage) {
    if (!requestedSqm || requestedSqm <= 0 || !packCoverage || packCoverage <= 0) return null;
    var packs       = Math.ceil(requestedSqm / packCoverage);
    var suppliedSqm = parseFloat((packs * packCoverage).toFixed(3));
    return { packs: packs, suppliedSqm: suppliedSqm };
  }

  /* Optional wastage %, added to the requested area before packs are
     calculated (mirrors "add X% waste" on other flooring calculators). */
  function getWastagePct() {
    var v = wastageInput ? parseFloat(wastageInput.value) : NaN;
    return (!v || isNaN(v) || v < 0) ? 0 : v;
  }

  /* ── Variants parsed from Liquid JSON embed ─────────────
     The Liquid outputs: <script id="frm-fp-variants-json">…</script>
     Each variant has { id, title } where title = "SQM" or "Room Size".
     We store a map of title → id so switchMode/syncCart can set
     the hidden #frm-fp-variant-id to the right Shopify variant.    */
  var variantIdBySku = {};
  (function () {
    var el = document.getElementById('frm-fp-variants-json');
    if (!el) return;
    try {
      var variants = JSON.parse(el.textContent || el.innerHTML);
      variants.forEach(function (v) {
        /* Match "SQM" and "Room Size" titles (case-insensitive, trimmed) */
        var key = (v.title || '').trim().toLowerCase();
        variantIdBySku[key] = v.id;
      });
    } catch (e) { /* malformed JSON — fall back to first variant */ }
  })();

  /* Returns the numeric Shopify variant ID for the current purchaseMode.
     Falls back to whatever is already in the hidden input. */
  function getVariantId() {
    var key = purchaseMode.toLowerCase();           // 'sqm' or 'room size'
    if (variantIdBySku[key]) return variantIdBySku[key];
    /* Fallback: first variant in the map */
    var keys = Object.keys(variantIdBySku);
    if (keys.length) return variantIdBySku[keys[0]];
    /* Last-resort: whatever Liquid already put in the hidden input */
    var el = document.getElementById('frm-fp-variant-id');
    return el ? el.value : '';
  }

  /* ── State ──────────────────────────────────────────────── */
  var purchaseMode = 'SQM';   // 'SQM' | 'Room Size'
  var isValid      = false;
  /* Tracks the most-recent valid calculation for use at submit time */
  var lastCalcResult = null;

  /* ── DOM refs ────────────────────────────────────────────── */
  var modeSqmBtn   = document.getElementById('ffc-mode-sqm');
  var modeRoomBtn  = document.getElementById('ffc-mode-room');
  var panelSqm     = document.getElementById('ffc-panel-sqm');
  var panelRooms   = document.getElementById('ffc-panel-rooms');
  var sqmInput     = document.getElementById('ffc-sqm-input');
  /* Optional wastage % field — only present on the new_flooring_products
     template. Absent everywhere else, so getWastagePct() below always
     returns 0 for the original template: zero behaviour change there. */
  var wastageInput = document.getElementById('ffc-wastage-input');
  var resultSqmEl  = document.getElementById('ffc-result-sqm');
  var resultRoomEl = document.getElementById('ffc-result-rooms');
  var roomsList    = document.getElementById('ffc-rooms-list');
  var addRoomBtn   = document.getElementById('ffc-add-room');
  var qtyHidden    = document.getElementById('frm-fp-qty');
  var addBtn       = document.getElementById('frm-fp-add-btn');
  var buyNowBtn    = document.getElementById('frm-fp-buy-now-btn');
  var cartNote     = document.querySelector('.frm-fp__cart-note');
  var mainImg      = document.getElementById('frm-fp-main-img');

  /* ── Gallery ─────────────────────────────────────────────── */
  var fpThumbs = document.querySelectorAll('.frm-fp__thumb');

  /* Build ordered image list (zoom-quality URLs preferred) */
  var fpGallery = [];
  fpThumbs.forEach(function (t) { fpGallery.push(t.dataset.zoom || t.dataset.full || t.src); });
  if (!fpGallery.length && mainImg) fpGallery.push(mainImg.dataset.zoom || mainImg.src);
  var fpIndex = 0;

  fpThumbs.forEach(function (t, i) {
    t.addEventListener('click', function () {
      fpIndex = i;
      if (mainImg) mainImg.src = t.dataset.full;
      fpThumbs.forEach(function (x) { x.classList.remove('active'); });
      t.classList.add('active');
    });
  });

  /* ── Lightbox ────────────────────────────────────────────── */
  var FP_LB = 'frm-fp-lb';

  function fpLbClose() {
    var el = document.getElementById(FP_LB);
    if (el) { document.body.removeChild(el); document.body.style.overflow = ''; }
    document.removeEventListener('keydown', fpLbKey);
  }

  function fpLbNav(dir) {
    fpIndex = (fpIndex + dir + fpGallery.length) % fpGallery.length;
    var lbImg = document.getElementById(FP_LB + '-img');
    var lbCnt = document.getElementById(FP_LB + '-cnt');
    if (lbImg) {
      lbImg.style.opacity = '0';
      setTimeout(function () { lbImg.src = fpGallery[fpIndex]; lbImg.style.opacity = '1'; }, 140);
    }
    if (lbCnt) lbCnt.textContent = (fpIndex + 1) + ' / ' + fpGallery.length;
  }

  function fpLbKey(e) {
    if (e.key === 'Escape')     fpLbClose();
    if (e.key === 'ArrowLeft')  fpLbNav(-1);
    if (e.key === 'ArrowRight') fpLbNav(1);
  }

  function fpLbOpen(index) {
    if (!fpGallery.length) return;
    fpIndex = index;
    if (document.getElementById(FP_LB)) return;

    var ov = document.createElement('div');
    ov.id = FP_LB;
    ov.style.cssText = 'position:fixed;inset:0;background:rgba(38, 38, 38, 0.92);z-index:9999;display:flex;align-items:center;justify-content:center;';
    ov.addEventListener('click', function (e) { if (e.target === ov) fpLbClose(); });

    var img = document.createElement('img');
    img.id  = FP_LB + '-img';
    img.src = fpGallery[fpIndex];
    img.style.cssText = 'max-width:90vw;max-height:88vh;object-fit:contain;border-radius:2px;transition:opacity 0.14s;display:block;';
    img.addEventListener('click', function (e) { e.stopPropagation(); });

    var xBtn = document.createElement('button');
    xBtn.innerHTML   = '&times;';
    xBtn.title       = 'Close';
    xBtn.style.cssText = 'position:absolute;top:14px;right:18px;background:rgba(245, 245, 245, 0.12);border:none;color:#F5F5F5;font-size:32px;line-height:1;width:44px;height:44px;border-radius:50%;cursor:pointer;z-index:2;display:flex;align-items:center;justify-content:center;';
    xBtn.addEventListener('click', fpLbClose);

    var cnt = document.createElement('div');
    cnt.id  = FP_LB + '-cnt';
    cnt.textContent = (fpIndex + 1) + ' / ' + fpGallery.length;
    cnt.style.cssText = 'position:absolute;bottom:18px;left:50%;transform:translateX(-50%);color:rgba(245, 245, 245, 0.7);font-size:13px;letter-spacing:0.06em;z-index:2;pointer-events:none;';
    if (fpGallery.length <= 1) cnt.style.display = 'none';

    var arrowStyle = 'position:absolute;top:50%;transform:translateY(-50%);background:rgba(245, 245, 245, 0.14);border:none;color:#F5F5F5;font-size:36px;width:52px;height:52px;border-radius:50%;cursor:pointer;z-index:2;display:flex;align-items:center;justify-content:center;transition:background 0.15s;';

    var prevBtn = document.createElement('button');
    prevBtn.innerHTML   = '&#8249;';
    prevBtn.title       = 'Previous image';
    prevBtn.style.cssText = arrowStyle + 'left:16px;';
    prevBtn.addEventListener('click', function (e) { e.stopPropagation(); fpLbNav(-1); });
    prevBtn.addEventListener('mouseover', function () { this.style.background = 'rgba(245, 245, 245, 0.28)'; });
    prevBtn.addEventListener('mouseout',  function () { this.style.background = 'rgba(245, 245, 245, 0.14)'; });

    var nextBtn = document.createElement('button');
    nextBtn.innerHTML   = '&#8250;';
    nextBtn.title       = 'Next image';
    nextBtn.style.cssText = arrowStyle + 'right:16px;';
    nextBtn.addEventListener('click', function (e) { e.stopPropagation(); fpLbNav(1); });
    nextBtn.addEventListener('mouseover', function () { this.style.background = 'rgba(245, 245, 245, 0.28)'; });
    nextBtn.addEventListener('mouseout',  function () { this.style.background = 'rgba(245, 245, 245, 0.14)'; });

    if (fpGallery.length <= 1) { prevBtn.style.display = 'none'; nextBtn.style.display = 'none'; }

    ov.appendChild(xBtn);
    ov.appendChild(prevBtn);
    ov.appendChild(nextBtn);
    ov.appendChild(img);
    ov.appendChild(cnt);
    document.body.appendChild(ov);
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', fpLbKey);
  }

  /* Click on main image to open lightbox */
  if (mainImg) {
    mainImg.style.cursor = 'zoom-in';
    mainImg.addEventListener('click', function () { fpLbOpen(fpIndex); });
  }

  /* ── Bottom product tabs ─────────────────────────────────── */
  document.querySelectorAll('.frm-fp__tab-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.frm-fp__tab-btn').forEach(function (b) { b.classList.remove('active'); });
      document.querySelectorAll('.frm-fp__tab-panel').forEach(function (p) { p.classList.remove('active'); });
      btn.classList.add('active');
      var panel = document.getElementById('frm-fp-tab-' + btn.dataset.tab);
      if (panel) panel.classList.add('active');
    });
  });

  /* ── Result render ───────────────────────────────────────── */
  function renderResult(el, data) {
    if (!el) return;
    if (!data) { el.innerHTML = ''; return; }
    var totalCost  = calcTotal(data.packs, data.suppliedSqm);
    var isPackMode = PRICING_MODE === 'pack';
    /* PACK_PRICE here is the actual per-quantity-unit rate charged at
       checkout (packs × PACK_PRICE = totalCost) — under the current
       pricing model that's numerically the same as the sqm rate, so
       there's no separate "Price per m²" figure to show without it
       being a redundant repeat of this same number. */
    var html =
      '<div class="calc-result">' +
        row('Requested Area',  data.requestedSqm.toFixed(2) + ' m²') +
        (data.wastagePct > 0 ? row('Wastage (' + data.wastagePct + '%)', '+' + fmtSqm(data.requestedSqm * data.wastagePct / 100) + ' m²') : '') +
        row('Supplied Area',   fmtSqm(data.suppliedSqm)     + ' m²') +
        row(data.isRoom ? 'Required Packs' : 'Packs', String(data.packs)) +
        (isPackMode && PACK_PRICE > 0 ? row('Price per Pack', fmt(PACK_PRICE)) : '') +
        (hasPrice() ? rowTotal(isPackMode ? 'Total Cost (GST inc.)' : 'Estimated Total', fmt(totalCost)) : '') +
      '</div>';
    el.innerHTML = html;
  }

  function row(label, value) {
    return '<div class="calc-result-row"><span class="calc-result-label">' + label +
      '</span><span class="calc-result-value">' + value + '</span></div>';
  }
  function rowTotal(label, value) {
    return '<div class="calc-result-row calc-result-row--total"><span class="calc-result-label">' + label +
      '</span><span class="calc-result-value">' + value + '</span></div>';
  }

  /* ── Cart sync ───────────────────────────────────────────── */
  function setAddBtnReady(ready) {
    if (!addBtn) return;
    var wasReady = addBtn.getAttribute('aria-disabled') !== 'true';
    addBtn.setAttribute('aria-disabled', ready ? 'false' : 'true');
    if (ready && !wasReady) {
      /* Transitioning from not-ready to ready — a brief "wake up" pulse
         so the shopper notices the CTA just became live. */
      addBtn.classList.remove('frm-fp__add-btn--just-enabled');
      /* eslint-disable-next-line no-unused-expressions */
      void addBtn.offsetWidth; /* restart animation if class was already removed async */
      addBtn.classList.add('frm-fp__add-btn--just-enabled');
    }
    /* Buy it now mirrors Add to Cart's readiness — same calculated area
       required before either can proceed. */
    if (buyNowBtn) buyNowBtn.setAttribute('aria-disabled', ready ? 'false' : 'true');
  }

  function syncCart(result, requestedSqm, wastagePct) {
    if (!result) {
      isValid        = false;
      lastCalcResult = null;
      if (qtyHidden) qtyHidden.value = 1;
      setAddBtnReady(false);
      if (cartNote)  {
        cartNote.textContent = 'Enter your area above to calculate';
        cartNote.classList.add('frm-fp__cart-note--pending');
        cartNote.classList.remove('frm-fp__cart-note--ready');
      }
      return;
    }

    isValid = true;
    /* Store result so the submit handler can read it */
    lastCalcResult = { packs: result.packs, suppliedSqm: result.suppliedSqm, requestedSqm: requestedSqm, purchaseMode: purchaseMode, wastagePct: wastagePct || 0 };

    /* Quantity = packs. Shopify cart quantity must be a whole integer —
       packs already is one (Math.ceil'd in calcPacks), so this is the
       only quantity basis with zero rounding drift between what the
       calculator shows and what checkout actually bills. In pack-price
       mode (PRICING_MODE) the variant price IS the per-pack price, so
       packs × price is exact; in legacy sqm mode the variant price is
       still per-m², so the checkout total there can run higher than
       the calculator's per-m² estimate until that product's price is
       migrated to a true per-pack amount. */
    if (qtyHidden) qtyHidden.value = String(result.packs);

    /* CHANGE 2: update the variant ID hidden input to match the selected mode */
    var varIdEl = document.getElementById('frm-fp-variant-id');
    if (varIdEl) varIdEl.value = getVariantId();

    setAddBtnReady(true);
    if (cartNote) {
      var totalCost = calcTotal(result.packs, result.suppliedSqm);
      var note = result.packs + ' pack' + (result.packs !== 1 ? 's' : '') +
        ' · ' + fmtSqm(result.suppliedSqm) + ' m² supplied';
      if (hasPrice()) note += ' · ' + fmt(totalCost);
      cartNote.textContent = note;
      cartNote.classList.remove('frm-fp__cart-note--pending');
      cartNote.classList.add('frm-fp__cart-note--ready');
    }
  }

  /* ── Mode 1: SQM ─────────────────────────────────────────── */
  function onSqmInput() {
    var req          = parseFloat(sqmInput && sqmInput.value);
    var wastagePct   = getWastagePct();
    /* Wastage inflates the area packs are calculated against, but the
       displayed/submitted "Requested Area" stays the raw figure typed —
       the wastage row shows the difference explicitly instead. */
    var effectiveReq = (req > 0 && wastagePct > 0) ? req * (1 + wastagePct / 100) : req;
    var result       = calcPacks(effectiveReq, PACK_COVERAGE);
    renderResult(resultSqmEl, result ? Object.assign({ requestedSqm: req, wastagePct: wastagePct }, result) : null);
    syncCart(result, req, wastagePct);
  }

  /* ── Mode 2: Room Size ───────────────────────────────────── */
  var roomCounter = 0;

  function addRoom() {
    roomCounter++;
    var id  = roomCounter;
    var div = document.createElement('div');
    div.className      = 'frm-calc__room';
    div.dataset.roomId = id;
    div.innerHTML =
      '<span class="frm-calc__room-label">Room ' + id + '</span>' +
      '<input class="frm-calc__room-input ffc-dim" type="number" min="0.01" step="0.01" placeholder="Length (m)" aria-label="Length m">' +
      '<input class="frm-calc__room-input ffc-dim" type="number" min="0.01" step="0.01" placeholder="Width (m)"  aria-label="Width m">' +
      '<span class="frm-calc__room-area ffc-room-area"></span>' +
      '<button class="frm-calc__room-remove" type="button" aria-label="Remove">&times;</button>';

    div.querySelectorAll('.ffc-dim').forEach(function (inp) {
      inp.addEventListener('input', function () {
        updateRoomArea(div);
        onRoomsChange();
      });
    });
    div.querySelector('.frm-calc__room-remove').addEventListener('click', function () {
      div.remove();
      onRoomsChange();
    });

    roomsList.appendChild(div);
    div.querySelector('input').focus();
    onRoomsChange();
  }

  function updateRoomArea(roomDiv) {
    var inputs = roomDiv.querySelectorAll('.ffc-dim');
    var l = parseFloat(inputs[0] && inputs[0].value) || 0;
    var w = parseFloat(inputs[1] && inputs[1].value) || 0;
    var chip = roomDiv.querySelector('.ffc-room-area');
    if (chip) chip.textContent = (l > 0 && w > 0) ? (l * w).toFixed(2) + ' m²' : '';
  }

  function onRoomsChange() {
    var total  = 0;
    var hasAny = false;
    roomsList.querySelectorAll('.frm-calc__room').forEach(function (room) {
      var inputs = room.querySelectorAll('.ffc-dim');
      var l = parseFloat(inputs[0] && inputs[0].value) || 0;
      var w = parseFloat(inputs[1] && inputs[1].value) || 0;
      if (l > 0 && w > 0) { total += l * w; hasAny = true; }
    });

    if (!hasAny) { renderResult(resultRoomEl, null); syncCart(null, 0); return; }

    var req    = parseFloat(total.toFixed(3));
    var result = calcPacks(req, PACK_COVERAGE);
    var data   = result ? Object.assign({ requestedSqm: req, isRoom: true }, result) : null;
    renderResult(resultRoomEl, data);
    syncCart(result, req);
  }

  /* ── Mode switching ──────────────────────────────────────── */
  function switchMode(mode) {
    purchaseMode = mode;
    var isSqm = (mode === 'SQM');

    if (modeSqmBtn)  modeSqmBtn.classList.toggle('active',  isSqm);
    if (modeRoomBtn) modeRoomBtn.classList.toggle('active', !isSqm);
    if (panelSqm)    panelSqm.classList.toggle('active',    isSqm);
    if (panelRooms)  panelRooms.classList.toggle('active',  !isSqm);

    /* reset */
    if (sqmInput && isSqm) sqmInput.value = '';
    renderResult(resultSqmEl, null);
    renderResult(resultRoomEl, null);
    syncCart(null, 0);

    if (!isSqm) onRoomsChange();
  }

  /* ── Form submit → open the theme's cart-drawer instead of
     redirecting to /cart. Mirrors the theme's own product-form pattern
     (assets/product.js): POST as FormData with a sections request so we
     get back freshly-rendered cart-drawer/main-cart/cart-bubble HTML,
     splice it in, then call the cart-drawer custom element's .open().
     The native form POST is still blocked via e.preventDefault() so
     Shopify's availability check stays bypassed at the HTTP level. */
  var FP_CART_DRAWER_SECTIONS = [
    { id: 'Cart',              section: 'main-cart',   selector: '.thb-cart-form' },
    { id: 'Cart',              section: 'main-cart',   selector: '.thb-cart-form--count' },
    { id: 'Cart-Drawer',       section: 'cart-drawer', selector: '.cart-drawer' },
    { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-secondary-area--item-count' },
    { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-secondary-area--item-amount' }
  ];

  function fpGetSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  function fpRenderCartSections(sections) {
    FP_CART_DRAWER_SECTIONS.forEach(function (s) {
      var container = document.getElementById(s.id);
      if (!container || !sections[s.section]) return;
      var target = container.querySelector(s.selector) || container;
      target.innerHTML = fpGetSectionInnerHTML(sections[s.section], s.selector);
    });

    /* Only open the drawer if its content actually arrived — never force
       it open showing stale/empty markup from initial page load. */
    var drawer = document.getElementById('Cart-Drawer');
    if (drawer && sections['cart-drawer'] && typeof drawer.open === 'function') {
      drawer.open();
      if (typeof drawer.removeProductEvent === 'function') drawer.removeProductEvent();
    }
  }

  /* Shared guard + FormData builder for both Add to Cart and Buy it now —
     same required calculation, same cart line properties, just a
     different thing happens after the /cart/add.js call succeeds.
     Returns null (after nudging the shopper to the input they need) if
     there's no valid calculation yet. */
  function prepareCartSubmission() {
    if (!lastCalcResult || lastCalcResult.packs < 1 || isNaN(lastCalcResult.packs)) {
      if (cartNote) {
        cartNote.textContent = 'Please enter your area first.';
        cartNote.classList.remove('frm-fp__cart-note--nudge');
        void cartNote.offsetWidth;
        cartNote.classList.add('frm-fp__cart-note--nudge');
      }

      /* In Room Size mode with no rooms added yet there's no input to
         focus — nudge toward "+ Add Room" instead of the hidden SQM
         field from the other panel. */
      var targetInput = (purchaseMode === 'Room Size')
        ? (roomsList && roomsList.querySelector('input[type="number"]')) || addRoomBtn
        : sqmInput;

      if (targetInput) {
        targetInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
        targetInput.classList.remove('frm-calc__input--nudge');
        void targetInput.offsetWidth;
        targetInput.classList.add('frm-calc__input--nudge');
        setTimeout(function () { targetInput.focus(); }, 250);
      }
      return null;
    }

    var variantId  = document.getElementById('frm-fp-variant-id').value;
    var packs      = Math.floor(lastCalcResult.packs);
    var isPackMode = PRICING_MODE === 'pack';

    var cartProperties = {
      'Purchase Mode':   lastCalcResult.purchaseMode || purchaseMode,
      'Requested Area':  lastCalcResult.requestedSqm.toFixed(2) + ' m²',
      'Supplied Area':   fmtSqm(lastCalcResult.suppliedSqm)     + ' m²',
      'Pack Coverage':   String(PACK_COVERAGE)                  + ' m² per pack',
      'Number of Packs': packs
    };
    if (lastCalcResult.wastagePct > 0) cartProperties['Wastage'] = lastCalcResult.wastagePct + '%';
    if (isPackMode && PACK_PRICE > 0) cartProperties['Price per Pack'] = fmt(PACK_PRICE);

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', packs);
    Object.keys(cartProperties).forEach(function (key) {
      formData.append('properties[' + key + ']', cartProperties[key]);
    });
    /* Shopify's /cart/add expects `sections` as ONE comma-joined value,
       not repeated multipart fields — appending it multiple times (even
       with unique values) makes it silently keep only one of them.
       FP_CART_DRAWER_SECTIONS maps several selectors to the same section
       name, so dedupe first, then send a single joined field. */
    var fpUniqueSections = FP_CART_DRAWER_SECTIONS
      .map(function (s) { return s.section; })
      .filter(function (name, i, arr) { return arr.indexOf(name) === i; });
    formData.append('sections', fpUniqueSections.join(','));
    formData.append('sections_url', window.location.pathname);

    return formData;
  }

  function showCartError(btn, message) {
    console.error('Cart error:', message);
    var errEl = document.getElementById('frm-fp-cart-error');
    if (!errEl) {
      errEl = document.createElement('p');
      errEl.id = 'frm-fp-cart-error';
      errEl.style.cssText = 'color:#262626;font-size:13px;margin-top:8px;';
      btn.closest('.frm-fp__cta-row').insertAdjacentElement('afterend', errEl);
    }
    errEl.textContent = message;
  }

  var form = document.getElementById('frm-fp-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();   /* always block the native POST */

      var formData = prepareCartSubmission();
      if (!formData) return;

      var btn = document.getElementById('frm-fp-add-btn');

      /* Disable button during request to prevent double submit */
      btn.disabled    = true;
      btn.textContent = 'Adding...';

      fetch((window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add.js', {
        method:  'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
        body: formData
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        btn.disabled    = false;
        btn.textContent = 'Add to Cart';
        if (data.status) {
          /* Shopify returned an error — show it inline, do not redirect */
          showCartError(btn, data.description);
          return;
        }
        if (data.sections) fpRenderCartSections(data.sections);
      })
      .catch(function (err) {
        btn.disabled    = false;
        btn.textContent = 'Add to Cart';
        showCartError(btn, 'Something went wrong adding this to your cart. Please try again.');
        console.error('Fetch error:', err);
      });
    });
  }

  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', function () {
      if (buyNowBtn.getAttribute('aria-disabled') === 'true') return;

      var formData = prepareCartSubmission();
      if (!formData) return;

      buyNowBtn.disabled    = true;
      buyNowBtn.textContent = 'Redirecting...';
      if (addBtn) addBtn.disabled = true;

      fetch((window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add.js', {
        method:  'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
        body: formData
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          buyNowBtn.disabled    = false;
          buyNowBtn.textContent = 'Buy it now';
          if (addBtn) addBtn.disabled = false;
          showCartError(buyNowBtn, data.description);
          return;
        }
        /* Straight to checkout — same destination the rug template's
           native name="checkout" submit button sends a shopper to. */
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        buyNowBtn.disabled    = false;
        buyNowBtn.textContent = 'Buy it now';
        if (addBtn) addBtn.disabled = false;
        showCartError(buyNowBtn, 'Something went wrong. Please try again.');
        console.error('Fetch error:', err);
      });
    });
  }

  /* ── Init ────────────────────────────────────────────────── */
  modeSqmBtn  && modeSqmBtn.addEventListener('click',  function () { switchMode('SQM'); });
  modeRoomBtn && modeRoomBtn.addEventListener('click', function () { switchMode('Room Size'); });
  sqmInput     && sqmInput.addEventListener('input', onSqmInput);
  wastageInput && wastageInput.addEventListener('input', onSqmInput);
  addRoomBtn   && addRoomBtn.addEventListener('click', addRoom);

  syncCart(null, 0);  /* disable Add to Cart on load */
  addRoom();          /* start with one room in the rooms panel */
  switchMode('SQM');  /* default mode */

})();
